module.exports = __webpack_public_path__ + "f8d7a05e252cdec68404ddf73489800d.svg";